<template>
    <v-container fluid>
        <v-row class="mb-2">
            <v-col cols="12" md="3" sm="6">
                <v-menu ref="start_day_menu" v-model="start_day_menu" :close-on-content-click="false"
                    :return-value.sync="queryForm.start_day" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="queryForm.start_day" label="开始日期" append-icon="mdi-calendar" readonly
                            v-bind="attrs" v-on="on" dense outlined clearable></v-text-field>
                    </template>
                    <v-date-picker v-model="queryForm.start_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
                        @input="() => { $refs.start_day_menu.save(queryForm.start_day); start_day_menu = false; }"></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" md="3" sm="6">
                <v-menu ref="end_day_menu" v-model="end_day_menu" :close-on-content-click="false"
                    :return-value.sync="queryForm.end_day" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="queryForm.end_day" label="结束日期" append-icon="mdi-calendar" readonly
                            v-bind="attrs" v-on="on" dense outlined clearable></v-text-field>
                    </template>
                    <v-date-picker v-model="queryForm.end_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
                        @input="() => { $refs.end_day_menu.save(queryForm.end_day); end_day_menu = false; }"></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" md="2" sm="6">
                <v-select v-model="queryForm.type" :items="typeOptions" item-text="label" item-value="value" label="类型"
                    no-data-text="无" dense outlined></v-select>
            </v-col>
            <v-col cols="12" md="2" sm="6">
                <v-select v-model="queryForm.status" :items="statusOptions" item-text="label" item-value="value"
                    label="状态" no-data-text="无" dense outlined></v-select>
            </v-col>
            <v-col cols="12" md="2" sm="6">
                <a-space>
                    <v-btn @click="getdata()" color="primary" dark tile>
                        <v-icon small>mdi-magnify</v-icon>查询
                    </v-btn>
                    <v-btn @click="openCreate" color="success" dark tile>
                        <v-icon small>mdi-plus</v-icon>新增消息
                    </v-btn>
                </a-space>
            </v-col>
        </v-row>

        <v-card>
            <v-card-title class="d-flex align-center py-2 px-3">
                <span class="text-subtitle-2">共 {{ length }} 页 / {{ count }} 条数据</span>
                <span v-if="selectedRowKeys.length" class="text-caption grey--text ml-3">
                    已选 {{ selectedRowKeys.length }} 条
                </span>
                <v-spacer></v-spacer>
                <a-space class="mr-2">
                    <v-btn small color="primary" dark tile :disabled="!selectedRowKeys.length" @click="batchSend">
                        <v-icon small left>mdi-send</v-icon>批量发送
                    </v-btn>
                    <v-btn small color="warning" dark tile :disabled="!selectedRowKeys.length" @click="batchRevoke">
                        <v-icon small left>mdi-undo-variant</v-icon>批量撤销
                    </v-btn>
                    <v-btn v-if="selectedRowKeys.length" small text tile @click="clearSelection">清空选择</v-btn>
                </a-space>
                <v-menu bottom offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn small outlined v-bind="attrs" v-on="on" class="grey lighten-3">
                            {{ limit }}/页
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="(item, index) in pages" :key="index" @click="changeLimit(item.value)">
                            <v-list-item-title>{{ item.value }}/页</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>
            <a-table size="small" :columns="headers" :data-source="list" row-key="_id" :pagination="false" bordered
                :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }" :row-selection="rowSelection">
                <template slot="index" slot-scope="text, record, index">
                    {{ index + 1 }}
                </template>

                <template slot="receiver" slot-scope="text, record">
                    <a-tag :color="record.type === 4 ? 'blue' : 'cyan'">
                        {{ record.type === 4 ? '全部' : (record.receiver || '司机') }}
                    </a-tag>
                </template>

                <template slot="content" slot-scope="text, record">
                    <v-btn color="primary" text dark tile @click="viewContent(record)">
                        查询详情
                    </v-btn>
                </template>
                <template slot="status" slot-scope="text, record">
                    <a-tag :color="statusColor(record.status)">
                        <span :class="{ 'status-revoked': record.status === 3 }">
                            {{ record.status_text || statusText(record.status) }}
                        </span>
                    </a-tag>
                </template>

                <template slot="send_time" slot-scope="text">
                    {{ text ? $moment(text).format("YYYY-MM-DD HH:mm:ss") : "--" }}
                </template>

                <template slot="action" slot-scope="text, record">
                    <a-space>
                        <a @click="openEdit(record)">编辑</a>
                        <a-divider type="vertical" />
                        <a-popconfirm title="确认删除该消息?" ok-text="确定" cancel-text="取消" placement="left"
                            @confirm="removeItem(record)">
                            <a class="error--text">删除</a>
                        </a-popconfirm>
                    </a-space>
                </template>
            </a-table>
        </v-card>

        <v-card tile class="mt-2">
            <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10"
                @input="onPageChange"></v-pagination>
        </v-card>

        <!-- 新增 / 编辑 / 查看消息弹窗 -->
        <v-dialog v-model="dialogVisible" max-width="800" persistent scrollable>
            <v-card>
                <v-card-title class="primary white--text">
                    {{ dialogMode === "create" ? "新增消息" : (dialogMode === "edit" ? "编辑消息" : "查看消息") }}
                </v-card-title>
                <v-card-text class="pt-4">
                    <v-text-field v-model="form.title" label="标题" dense outlined :disabled="dialogMode === 'view'" />
                    <v-text-field v-model="form.summary" label="概要" dense outlined :disabled="dialogMode === 'view'" />
                    <v-text-field :value="typeText(form.type)" label="类型" dense outlined disabled
                        :hint="dialogMode !== 'view' ? '手动新增消息固定为「系统」类型' : ''" persistent-hint></v-text-field>

                    <quill ref="quill" v-if="dialogMode !== 'view'" :content="form.content" placeholder="请输入消息内容" />
                    <div v-else class="content-preview" v-html="form.content"></div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogVisible = false">取消</v-btn>
                    <v-btn v-if="dialogMode !== 'view'" color="primary" dark tile @click="submitForm">保存</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- 仅查看消息详情弹窗（来自列表"查看详情"） -->
        <v-dialog v-model="viewVisible" max-width="800" scrollable>
            <v-card>
                <v-card-title class="primary white--text">消息详情</v-card-title>
                <v-card-text class="pt-4">
                    <div class="d-flex align-center mb-2">
                        <span class="text-h6 mr-2">{{ viewing.title }}</span>
                        <a-tag :color="statusColor(viewing.status)">{{ viewing.status_text || statusText(viewing.status)
                            }}</a-tag>
                    </div>
                    <div class="grey--text mb-2">概要：{{ viewing.summary }}</div>
                    <div class="grey--text mb-3">
                        时间：{{ viewing.send_time ? $moment(viewing.send_time).format("YYYY-MM-DD HH:mm:ss") : "--" }}
                    </div>
                    <div class="content-preview" v-html="viewing.content"></div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="viewVisible = false">关闭</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
import quill from "@/components/quill.vue";

export default {
    name: "ManageMessage",
    components: { quill },
    data() {
        return {
            pages: [
                { text: "20/页", value: 20 },
                { text: "50/页", value: 50 },
                { text: "100/页", value: 100 },
            ],
            selectedRowKeys: [],
            selectedRows: [],
            queryForm: {
                start_day: this.$moment().format("YYYY-MM-DD"),
                end_day: this.$moment().format("YYYY-MM-DD"),
                type: null,
                status: null,
            },
            typeOptions: [
                { label: "全部", value: null },
                { label: "任务", value: 1 },
                { label: "挪挂", value: 2 },
                { label: "报修", value: 3 },
                { label: "系统", value: 4 },
            ],
            statusOptions: [
                { label: "全部", value: null },
                { label: "已发送", value: 1 },
                { label: "未发送", value: 2 },
                { label: "已撤销", value: 3 },
            ],
            headers: [
                { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
                { title: "标题", dataIndex: "title", scopedSlots: { customRender: "title" }, width: 200, align: "left" },
                { title: "概要", dataIndex: "summary", scopedSlots: { customRender: "summary" }, width: 240, align: "left" },
                { title: "内容（详情）", dataIndex: "content", scopedSlots: { customRender: "content" }, width: 120, align: "center" },
                { title: "接收人", dataIndex: "receiver", scopedSlots: { customRender: "receiver" }, width: 100, align: "center" },
                { title: "状态", dataIndex: "status", scopedSlots: { customRender: "status" }, width: 110, align: "center" },
                { title: "时间", dataIndex: "send_time", scopedSlots: { customRender: "send_time" }, width: 170, align: "center" },
                { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 140, align: "center" },
            ],
            list: [],
            page: 1,
            limit: 20,
            count: 0,
            length: 0,
            // mock 开关：true=使用本地模拟数据；接口联调后改为 false
            useMock: true,
            height: 600,
            start_day_menu: false,
            end_day_menu: false,
            // 弹窗
            dialogVisible: false,
            dialogMode: "create", // create / view
            form: { title: "", summary: "", content: "", type: 1 },
            // 列表行查看
            viewVisible: false,
            viewing: {},
        };
    },
    computed: {
        ...mapState(["role", "username"]),
        width() {
            return _.reduce(this.headers, (a, b) => a + (b.width || 200), 0);
        },
        totalPage() {
            return this.length || 1;
        },
        rowSelection() {
            return {
                selectedRowKeys: this.selectedRowKeys,
                onChange: (keys, rows) => {
                    this.selectedRowKeys = keys;
                    this.selectedRows = rows;
                },
            };
        },
    },
    watch: {
        page() { this.getdata(); },
        limit() { this.changeLimit(this.limit); },
    },
    mounted() {
        this.height = window.innerHeight - 280;
        window.onresize = () => { this.height = window.innerHeight - 280; };
        this.getdata();
    },
    methods: {
        statusText(s) {
            return { 1: "已发送", 2: "未发送", 3: "已撤销" }[s] || "--";
        },
        statusColor(s) {
            return { 1: "green", 2: "orange", 3: "red" }[s] || "default";
        },
        typeText(t) {
            return { 1: "任务", 2: "挪挂", 3: "报修", 4: "系统" }[t] || "--";
        },
        getdata() {
            // 先使用模拟数据（接口待后端联调）
            const mock = [
                {
                    _id: "m1",
                    title: "豫A37301D 任务派车提醒",
                    summary: "商丘→郑州 09:00 准时发车，请提前 30 分钟到岗",
                    content: "<p><strong>任务派车：</strong></p><p>线路：商丘→郑州（商1）</p><p>发车时间：2026-08-14 09:00</p><p>挂箱：皖CX541挂</p>",
                    type: 1,
                    status: 1,
                    send_time: "2026-08-13 08:30:00",
                },
                {
                    _id: "m2",
                    title: "挪挂通知",
                    summary: "请将豫A12345 挂箱从 A 区挪至 B 区 12 号位",
                    content: "<p>挪挂原因：场地调整</p><p>目标位置：B 区 12 号位</p><p>请于今日 18:00 前完成</p>",
                    type: 2,
                    status: 2,
                    send_time: "",
                },
                {
                    _id: "m3",
                    title: "车辆报修受理",
                    summary: "豫B88888 报修已受理，预计 2 小时内反馈",
                    content: "<p>报修项：刹车异响</p><p>受理时间：2026-08-13 14:20</p>",
                    type: 3,
                    status: 1,
                    send_time: "2026-08-13 14:25:00",
                },
                {
                    _id: "m4",
                    title: "系统升级公告",
                    summary: "今晚 23:00-01:00 系统维护，请提前保存",
                    content: "<p>维护窗口：23:00 - 01:00</p><p>影响范围：运单录入、车辆监控</p>",
                    type: 4,
                    status: 3,
                    send_time: "2026-08-12 10:00:00",
                },
                {
                    _id: "m5",
                    title: "任务派车提醒",
                    summary: "商丘→安阳 晚班 19:30 发车",
                    content: "<p>线路：商丘→安阳（商1）</p><p>发车时间：2026-08-13 19:30</p>",
                    type: 1,
                    status: 2,
                    send_time: "",
                },
            ];
            this.list = mock.map((it) => ({ ...it, status_text: this.statusText(it.status) }));
            this.count = mock.length;
            this.length = Math.max(1, Math.ceil(this.count / this.limit));
            this.selectedRowKeys = [];
            this.selectedRows = [];
            return;
        },
        onPageChange() { this.getdata(); },
        changeLimit(v) {
            this.limit = v;
            this.page = 1;
            this.getdata();
        },
        openCreate() {
            this.form = { _id: "", title: "", summary: "", content: "", type: 4 };
            this.dialogMode = "create";
            this.dialogVisible = true;
        },
        openEdit(record) {
            this.form = {
                _id: record._id,
                title: record.title || "",
                summary: record.summary || "",
                content: record.content || "",
                type: record.type || 4,
            };
            this.dialogMode = "edit";
            this.dialogVisible = true;
        },
        submitForm() {
            if (!this.form.title || !this.form.summary || !this.form.content) {
                return this.$alert("标题、概要、内容均不能为空");
            }
            // mock 模式：直接本地增删改
            if (this.useMock) {
                if (this.dialogMode === "create") {
                    const id = "m" + Date.now();
                    const item = { ...this.form, _id: id, status: 2, send_time: "", status_text: this.statusText(2) };
                    this.list = [item, ...this.list];
                    this.count = this.list.length;
                    this.length = Math.max(1, Math.ceil(this.count / this.limit));
                    this.$message.success("保存成功");
                }
                else if (this.dialogMode === "edit") {
                    this.list = this.list.map((it) =>
                        it._id === this.form._id
                            ? { ...it, title: this.form.title, summary: this.form.summary, content: this.form.content, type: this.form.type }
                            : it
                    );
                    this.$message.success("已更新");
                }
                this.dialogVisible = false;
                return;
            }
            this.$toast.loading({ message: "" });
            this.$api
                .doAPI("/manage/message/save", { ...this.form, status: 2 })
                .then((res) => {
                    this.$toast.clear();
                    if (res.code === 0) {
                        this.$message.success("保存成功");
                        this.dialogVisible = false;
                        this.getdata();
                    }
                    else {
                        this.$alert(res.msg);
                    }
                })
                .catch((err) => {
                    this.$toast.clear();
                    this.$alert(err.message || "保存失败");
                });
        },
        removeItem(record) {
            if (this.useMock) {
                this.list = this.list.filter((it) => it._id !== record._id);
                this.count = this.list.length;
                this.length = Math.max(1, Math.ceil(this.count / this.limit));
                this.$message.success("已删除");
                return;
            }
            this.$toast.loading({ message: "" });
            this.$api
                .doAPI("/manage/message/remove", { _id: record._id })
                .then((res) => {
                    this.$toast.clear();
                    if (res.code === 0) {
                        this.$message.success("已删除");
                        this.getdata();
                    }
                    else {
                        this.$alert(res.msg);
                    }
                })
                .catch((err) => {
                    this.$toast.clear();
                    this.$alert(err.message || "删除失败");
                });
        },
        viewContent(record) {
            this.viewing = { ...record };
            this.viewVisible = true;
        },
        clearSelection() {
            this.selectedRowKeys = [];
            this.selectedRows = [];
        },
        batchSend() {
            if (!this.selectedRows.length) return this.$message.warning("请先选择要发送的消息");
            // 仅允许"未发送 / 已撤销"的消息执行发送
            const sendable = this.selectedRows.filter((it) => it.status === 2 || it.status === 3);
            if (!sendable.length) {
                return this.$alert("所选消息中没有可发送的（已发送的消息不能重复发送）");
            }
            const skip = this.selectedRows.length - sendable.length;
            this.$confirm1(
                "批量发送",
                `确定发送选中的 ${sendable.length} 条消息？${skip ? `（已自动跳过 ${skip} 条已发送消息）` : ""}`,
                () => this.doBatchSend(sendable)
            );
        },
        doBatchSend(rows) {
            if (this.useMock) {
                const ids = rows.map((it) => it._id);
                const now = this.$moment().format("YYYY-MM-DD HH:mm:ss");
                this.list = this.list.map((it) =>
                    ids.includes(it._id)
                        ? { ...it, status: 1, status_text: this.statusText(1), send_time: now }
                        : it
                );
                this.$message.success(`已发送 ${rows.length} 条`);
                this.clearSelection();
                return;
            }
            this.$toast.loading({ message: "发送中..." });
            this.$api
                .doAPI("/manage/message/batchSend", { ids: rows.map((it) => it._id) })
                .then((res) => {
                    this.$toast.clear();
                    if (res.code === 0) {
                        this.$message.success(`已发送 ${rows.length} 条`);
                        this.clearSelection();
                        this.getdata();
                    }
                    else {
                        this.$alert(res.msg);
                    }
                })
                .catch((err) => {
                    this.$toast.clear();
                    this.$alert(err.message || "批量发送失败");
                });
        },
        batchRevoke() {
            if (!this.selectedRows.length) return this.$message.warning("请先选择要撤销的消息");
            // 仅"已发送"的消息可被撤销
            const revokable = this.selectedRows.filter((it) => it.status === 1);
            if (!revokable.length) {
                return this.$alert("所选消息中没有可撤销的（仅已发送的消息可撤销）");
            }
            const skip = this.selectedRows.length - revokable.length;
            this.$confirm1(
                "批量撤销",
                `确定撤销选中的 ${revokable.length} 条消息？${skip ? `（已自动跳过 ${skip} 条不可撤销消息）` : ""}`,
                () => this.doBatchRevoke(revokable)
            );
        },
        doBatchRevoke(rows) {
            if (this.useMock) {
                const ids = rows.map((it) => it._id);
                this.list = this.list.map((it) =>
                    ids.includes(it._id)
                        ? { ...it, status: 3, status_text: this.statusText(3) }
                        : it
                );
                this.$message.success(`已撤销 ${rows.length} 条`);
                this.clearSelection();
                return;
            }
            this.$toast.loading({ message: "撤销中..." });
            this.$api
                .doAPI("/manage/message/batchRevoke", { ids: rows.map((it) => it._id) })
                .then((res) => {
                    this.$toast.clear();
                    if (res.code === 0) {
                        this.$message.success(`已撤销 ${rows.length} 条`);
                        this.clearSelection();
                        this.getdata();
                    }
                    else {
                        this.$alert(res.msg);
                    }
                })
                .catch((err) => {
                    this.$toast.clear();
                    this.$alert(err.message || "批量撤销失败");
                });
        },
    },
};
</script>

<style lang="less" scoped>
.text-truncate-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
}

.content-label {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
}

.content-preview {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 8px 12px;
    min-height: 120px;
    background: #fafafa;
    word-break: break-all;

    /deep/ img {
        max-width: 100%;
    }

    /deep/ p {
        margin: 4px 0;
    }
}

.status-revoked {
    text-decoration: line-through;
}
</style>
